<template>
  <div>
    <el-form
      :model="listForm"
      ref="listForm"
      :rules="releaseRules"
      class="editForm"
      label-width="168px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户名" prop="payerName">
            <el-input v-model="listForm.payerName" placeholder="请填写开户名"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行类别" prop="payerBankType">
            <bsp-dicts-select
              v-model="listForm.payerBankType"
              ref = "payerBankType"
              dic-num="3151"
              :select-value.sync="listForm.payerBankType"
              @selectChange="selectChangeBankType"
              placeholder="请选择银行类别"
            />
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行账号" prop="payerBankAccount">
            <el-input v-model="listForm.payerBankAccount" type="number" placeholder="请填写开户行账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行全称" prop="payerBankFullname">
            <el-input v-model="listForm.payerBankFullname"
                      placeholder="请填写开户行全称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="默认发薪银行" prop="ifDefault">
<!--            <el-input v-model="listForm.ifDefault" />-->
            <bsp-dicts-select
              v-model="listForm.ifDefault"
              ref = "ifDefault"
              dic-num="1002"
              :select-value.sync="listForm.ifDefault"
              @selectChange="selectChangeIsDefault"
              placeholder="请选择默认发薪银行"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属机构" prop="orgId">
<!--            &lt;!&ndash; 调用树形下拉框组件 &ndash;&gt;-->
<!--            <ciic-tree-select-->
<!--              :props="props"-->
<!--              :options="treeList2"-->
<!--              :value="valueId"-->
<!--              @getValue="getValue($event)"-->
<!--              placeholder="请选择所属机构"-->
<!--            >-->
<!--            </ciic-tree-select>-->
            <el-select v-model="listForm.orgId" placeholder="请选择机构">
              <el-option
                v-for="item in cusOrgList"
                :key="item.id"
                :label="item.orgName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import bspSelectTree from "@/components/bsp/bsp-select-tree/bsp-select-tree";
import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
import { isvalidatemobile, cardid } from "@/util/validate";
import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
import { init,codeList,codeToName,nameToCode,getCodeNames,getNameCodes} from "@/components/bsp/code/frontCode";
import {getCompanyOrg} from "@/api/org/org";
import store from '@/store';

export default {
  components: {
    CiicTreeSelect,
    bspDictsSelect,
    bspSelectTree
  },
  name: "Dialog",
  props: {
    listForm: {
      type: Object,
      default: () => ({})
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: ""
    }
  },
  watch: {
    listForm: {
      handler(newVal, oldVal) {
        // this.$refs.listForm.resetFields();
        // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
        this.$emit("update:listForm", newVal);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    init('city');
    this._getCompanyOrg();
  },
  mounted() {},
  data() {
    const validateIdcard = (rule, value, callback) => {
      if (this.listForm.idType == "00340001") {
        if (cardid(value)[0]) {
          callback(new Error(cardid(value)[1]));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      options: codeList,
      selectedOptions: [],
      disabled: true,
      showCropAvatar: false,
      photo: "",
      releaseRules: {
          payerName: [{ required: true, message: "开户名不能为空", trigger: "blur" },
          { max:20, message: '不能超过20个字符', trigger:"blur"}],
        // 引用基本的 校验
          payerBankType: [{ required: true, message:'银行类别不能为空', trigger: "blur" }],
          payerBankAccount: [{ required: true, message: "开户行账号不能为空", trigger: "blur" },
          { max:20, message: '不能超过20个字符', trigger: 'blur' },],
          payerBankFullname: [{ required: true, message: "开户银行全称不能为空", trigger: "blur" },
          { max:20, message: '不能超过20个字符', trigger: 'blur' }],
          ifDefault: [{ required: true, message: "默认发薪银行不能为空", trigger: "blur" }],
          orgId: [{ required: true, message: "所属机构不能为空", trigger: "blur" }],
      },
      sexList: [{ value: "1", label: "女" }, { value: "2", label: "男" }],
      props: {
        // 配置项（必选）
        value: "id",
        label: "orgName",
        children: "children"
      },
      cusOrgList: [],
      valueId: null,
    };
  },
  methods: {
    /*clearValidate(){
      this.$refs.listForm.clearValidate();
    },*/
    toggleShowCropAvatar() {
      this.showCropAvatar = !this.showCropAvatar;
    },
    handleUploadSuccess(res, field) {
      console.log(res);
      this.listForm.photo = res.fileId;
    },
    // 取值
    getValue(value){
        this.valueId = value
    },
    handleChange(v){},
    // 查询分公司
    _getCompanyOrg() {
        getCompanyOrg(store.getters.cusId).then((res) => {
            this.cusOrgList = res.data
        });
    },
    selectChangeIsDefault(value){
      this.listForm.ifDefault = value
    },
    selectChangeBankType(value){
      this.listForm.payerBankType = value
    }

  }
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-left: 30px;
  margin-bottom: 5px;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
  margin-left: 30px;
  margin-bottom: 5px;
}
</style>
